// Types

export type AdType = null | 'SALARY_SURVEY' | 'RESUME_DB' | 'GRAD_FAIRS';

export type MainStoreLayoutState = {
  withSearchHero: boolean;
  adTypeOnPageLoad: AdType;
};

export type SetWithSearchHeroAction = {
  type: 'SET_WITH_SEARCH_HERO';
  payload: {
    withSearchHero: boolean;
  };
};

export type SetAdTypeOnPageLoadType = {
  type: 'SET_AD_TYPE_ON_PAGE_LOAD';
  payload: {
    adType: AdType;
  };
};

export type MainStoreLayoutAction =
  | SetWithSearchHeroAction
  | SetAdTypeOnPageLoadType;

// Reducer

const initialState = {
  adTypeOnPageLoad: null,
  withSearchHero: true,
};

export function layoutReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreLayoutState = initialState,
  action: MainStoreLayoutAction,
) {
  switch (action.type) {
    case 'SET_WITH_SEARCH_HERO':
      return { ...state, withSearchHero: action.payload.withSearchHero };

    case 'SET_AD_TYPE_ON_PAGE_LOAD':
      return {
        ...state,
        adTypeOnPageLoad: action.payload.adType,
      };

    default:
      return state;
  }
}
